import { render, staticRenderFns } from "./search-to-add.vue?vue&type=template&id=e516463a&scoped=true&"
import script from "./search-to-add.vue?vue&type=script&lang=js&"
export * from "./search-to-add.vue?vue&type=script&lang=js&"
import style0 from "./search-to-add.vue?vue&type=style&index=0&id=e516463a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e516463a",
  null
  
)

export default component.exports